import React, { useEffect } from 'react';

const Notification = ({ message, type = 'info', onClose }) => {
  useEffect(() => {
    // Auto close after 5 seconds
    if (onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [onClose]);

  const getNotificationStyles = () => {
    const baseStyles = 'fixed top-4 left-4 right-4 sm:left-auto sm:right-4 z-50 flex items-center space-x-3 px-6 py-4 rounded-lg shadow-lg sm:max-w-md transform transition-all duration-300 ease-in-out';
    
    switch (type) {
      case 'success':
        return `${baseStyles} bg-green-50 dark:bg-green-950/40 border-l-4 border-green-500`;
      case 'error':
        return `${baseStyles} bg-red-50 dark:bg-red-950/40 border-l-4 border-red-500`;
      case 'warning':
        return `${baseStyles} bg-yellow-50 dark:bg-yellow-950/40 border-l-4 border-yellow-500`;
      case 'info':
        return `${baseStyles} bg-blue-50 dark:bg-blue-950/40 border-l-4 border-blue-500`;
      default:
        return `${baseStyles} bg-gray-50 dark:bg-stone-800 border-l-4 border-gray-500`;
    }
  };

  const getIconStyles = () => {
    switch (type) {
      case 'success':
        return 'text-green-500';
      case 'error':
        return 'text-red-500';
      case 'warning':
        return 'text-yellow-500';
      case 'info':
        return 'text-blue-500';
      default:
        return 'text-gray-500';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'fa-check-circle';
      case 'error':
        return 'fa-exclamation-circle';
      case 'warning':
        return 'fa-exclamation-triangle';
      case 'info':
        return 'fa-info-circle';
      default:
        return 'fa-bell';
    }
  };

  const getTextColor = () => {
    switch (type) {
      case 'success':
        return 'text-green-800 dark:text-green-300';
      case 'error':
        return 'text-red-800 dark:text-red-300';
      case 'warning':
        return 'text-yellow-800 dark:text-yellow-300';
      case 'info':
        return 'text-blue-800 dark:text-blue-300';
      default:
        return 'text-gray-800 dark:text-stone-300';
    }
  };

  return (
    <div className={getNotificationStyles()}>
      <div className={`flex-shrink-0 ${getIconStyles()}`}>
        <i className={`fas ${getIcon()} text-xl`}></i>
      </div>
      <div className="flex-1">
        <p className={`font-medium ${getTextColor()}`}>{message}</p>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className={`flex-shrink-0 ${getTextColor()} hover:opacity-75 transition-opacity`}
        >
          <i className="fas fa-times"></i>
        </button>
      )}
    </div>
  );
};

export default Notification;

